export interface DestinationApiRawResponse {
  groupItems: Group[]
}

interface Group {
  group: DestinationGroup
  options: { name: string, url: string, isSelected: boolean }[]
}

export const destinationGroup = {
  Country: 'country',
  Region: 'region',
  Subregion: 'subregion',
  City: 'city',
} as const

export type DestinationGroup =
  (typeof destinationGroup)[keyof typeof destinationGroup]
